var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":_vm.label,"items":_vm.selectItems,"clearable":""},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }